export default __webpack_public_path__ + "static/media/logo-company-13.931c6cca.png";